import { Component } from "@/types"
import { Stack } from "@/ui/atoms/layout/Stack"
import { Icon } from "@/ui/atoms/media/Icon"
import { cx } from "@/utils/cx"
import { tx } from "@/utils/tx"

export const COMPONENT_NAME = "quoteBlock"

export const presets = {}

export interface Props extends Component {
  quote: string
  author: string
  role: string
}

export function QuoteBlock({ quote, author, role, className, testId = COMPONENT_NAME }: Props) {
  return (
    <div className={cx(`pl-5 relative`, className)} data-test={testId}>
      <Icon name="quoteLg" className="text-current -ml-1" testId={tx(testId, "icon")} />
      <Stack className="gap-3">
        <div className="text-text-secondary font-light italic" data-test={tx(testId, "quote")}>
          {quote}
        </div>
        <Stack>
          <div className="text-sm text-text font-semibold" data-test={tx(testId, "author")}>
            {author}
          </div>
          <div className="text-sm text-text-secondary font-light" data-test={tx(testId, "role")}>
            {role}
          </div>
        </Stack>
      </Stack>

      <div className="absolute inset-0 right-auto w-1 bg-current"></div>
    </div>
  )
}
